import React from 'react';
import ExtendSearchBase from './ExtendSearchBase';
import { RENTDAILY, APARTMENTS } from '../../../consts';
import { Checkbox } from '../../Controls';
import { getAgencies } from '../../../utils/dictionaries';

class RentDailyApartments extends ExtendSearchBase {
  constructor (props) {
    super(props);
    this.displayName = 'rentCommercials';
    const dic = props.dictionary;

    this.buildingTypeItems = dic.getBuildingTypeItems(RENTDAILY, APARTMENTS);
    this.renovationTypeItems = dic.getRenovationTypeItems(RENTDAILY, APARTMENTS);
    this.applicationItems = dic.getApplicationItems(RENTDAILY, APARTMENTS);
    this.trinityExistNoItems = dic.getTrinityExistNoItems();
    this.agenciesList = getAgencies(props.agenciesList, this.displayName);
  }

  renderPanel () {
    return (<div>
      <div className='filter-section__container'>
        <h3 className='title'>Параметры квартиры</h3>
        <div className='container__row'>
          <div className='container__column'>
            {this.renderInputGroup('Кол-во спальных мест', null, [
              {name: 'numberOfBedsMin', placeholder: 'От', handler: this.getHandlerInt('numberOfBedsMin', 2)},
              {name: 'numberOfBedsMax', placeholder: 'До', handler: this.getHandlerInt('numberOfBedsMax', 2)}
            ])}
            {this.renderControlGroup('Удобства', (
              <div>
                <Checkbox
                  label='Холодильник'
                  checked={this.getFilter('hasFridge')}
                  onUpdate={(_, state) => this.setFilter('hasFridge', state ? 1 : null)}
                />
                <Checkbox
                  label='Телевизор'
                  checked={this.getFilter('hasTV')}
                  onUpdate={(_, state) => this.setFilter('hasTV', state ? 1 : null)}
                />
                <Checkbox
                  label='Стиральная машина'
                  checked={this.getFilter('hasWashingMachine')}
                  onUpdate={(_, state) => this.setFilter('hasWashingMachine', state ? 1 : null)}
                />
                <Checkbox
                  label='Кондиционер'
                  checked={this.getFilter('hasConditioning')}
                  onUpdate={(_, state) => this.setFilter('hasConditioning', state ? 1 : null)}
                />
                <Checkbox
                  label='Интернет'
                  checked={this.getFilter('hasInternet')}
                  onUpdate={(_, state) => this.setFilter('hasInternet', state ? 1 : null)}
                />
              </div>
            ))}
          </div>
          <div className='container__column'>
            {this.renderMultiSelect('Состояние / ремонт', 'renovationTypeId', this.renovationTypeItems, true)}
          </div>
          <div className='container__column'>
            {this.renderMultiSelect('Тип дома', 'buildingTypeId', this.buildingTypeItems, true)}
          </div>
        </div>
      </div>

      <div className='filter-section__container'>
        <h3 className='title'>Прочие параметры</h3>
          <div className='container__row'>
            <div className='container__column'>
              {this.getUserIsAdmin() && this.renderMultiSelect('Приложения', 'sourceAppId', this.applicationItems, true)}
              {this.renderMultiSelect('Агентство / застройщик', 'agencyId', this.agenciesList, true, 'Неважно', true)}
            </div>
            <div className='container__column'>
              {this.renderInputGroup('Поиск в описании', null, [
                {name: 'description', placeholder: 'Ключевые слова', handler: this.getHandlerString('description')}
              ])}
              {this.renderInputGroup('Контактный телефон', null, [
                {name: 'contactPhone', placeholder: '123 456 78 90', handler: this.getHandlerInt('contactPhone')}
              ])}
            </div>
            <div className='container__column'>
              {this.renderInputGroup('Номер объявления', null, [
                {name: 'id', placeholder: '12345678', handler: this.getHandlerInt('id')}
              ])}
            </div>
          </div>
      </div>
    </div>);
  }
}

export default RentDailyApartments;



// WEBPACK FOOTER //
// ./src/ui/Search/ExtendSearch/RentDailyApartments.jsx